// Pure status→label mapping for the Activity screen (item 6). i18n's index.ts is
// import-safe in the node unit bundle (its detect() guards missing browser
// globals), so translating here doesn't pull a DOM dependency into the tests.

import { t } from "../i18n/index.ts";

/** User-facing label for a stored challenge status ("created" reads as
 *  "pending"; anything unknown passes through unchanged). */
export function statusLabel(status: string): string {
  const map: Record<string, string> = {
    created: "status.pending",
    accepted: "status.accepted",
    declined: "status.declined",
    expired: "status.expired",
    canceled: "status.canceled",
  };
  const key = map[status];
  return key ? t(key) : status;
}
